import dateFormat from 'dateformat';

export const responseFile = ({
  data,
  format,
  filename = 'export',
  onRequestEnd = () => {},
}) => {
  // create file link in browser's memory
  const href = URL.createObjectURL(data);
  // create "a" HTML element with href to file & click
  const link = document.createElement('a');
  link.href = href;
  const date = new Date();
  link.setAttribute(
    'download',
    `${filename}-${dateFormat(date, 'defaultDate')}.${format}`
  );
  document.body.appendChild(link);
  onRequestEnd();
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
